const ALLOWED_STREAM_HOSTS = ["youtube.com", "www.youtube.com", "youtu.be", "twitch.tv", "www.twitch.tv", "facebook.com", "www.facebook.com"];

export function isAllowedStreamUrl(value: string | null | undefined): boolean {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "https:" && ALLOWED_STREAM_HOSTS.some((host) => url.hostname === host || url.hostname.endsWith(`.${host}`));
  } catch {
    return false;
  }
}
